import React from 'react';

interface Expense {
    description: string;
    amount: number;
    paidBy: string;
    splitAmong?: string[];
}

interface SummaryCardProps {
    totalAmount: number;
    perPersonAmount: number;
    expenses: Expense[];
}

export const SummaryCard: React.FC<SummaryCardProps> = ({
    totalAmount,
    perPersonAmount,
    expenses
}) => {
    return (
        <div className="summary-card">
            <div className="summary-header">
                <div className="summary-icon">💰</div>
                <div className="summary-info">
                    <div className="summary-label">총 지출</div>
                    <div className="summary-amount">{totalAmount.toLocaleString('ko-KR')}원</div>
                    <div className="summary-per-person">
                        1인당 {perPersonAmount.toLocaleString('ko-KR')}원
                    </div>
                </div>
            </div>

            {expenses.length > 0 && (
                <div className="summary-breakdown">
                    <div className="summary-breakdown-title">지출 내역</div>
                    <div className="summary-breakdown-list">
                        {expenses.map((expense, index) => (
                            <div key={index} className="summary-breakdown-item">
                                <div className="summary-breakdown-info">
                                    <div className="summary-breakdown-name">{expense.description}</div>
                                    <div className="summary-breakdown-payer-row">
                                        <span className="summary-breakdown-payer">지불: {expense.paidBy}</span>
                                        {expense.splitAmong && expense.splitAmong.length > 0 && (
                                            <div className="summary-breakdown-split-list">
                                                {expense.splitAmong.map((name, idx) => (
                                                    <span key={idx} className="summary-split-badge">{name}</span>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="summary-breakdown-amount">
                                    {expense.amount.toLocaleString('ko-KR')}원
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};
